<lib-ags-kendo-grid-list
  [titlefield]="'Mes Formations'"
  [gridConfig]="gridSettings"
  [downloadFunction]="documentService.getDocumentPresigned"
  [table]="'session'"
  [data]="listformation | async"
>
</lib-ags-kendo-grid-list>